// Manual "Run Training" on a pipeline (POST /pipelines/:id/train).
const action = "MODEL_RUN_TRAINING";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { modelId }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
